export default __webpack_public_path__ + "static/media/24.2d3a9df9.jpg";